var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1665 5.33337C4.95737 5.33337 3.1665 7.12423 3.1665 9.33337V22.6667C3.1665 24.8758 4.95736 26.6667 7.1665 26.6667H25.8332C28.0423 26.6667 29.8332 24.8758 29.8332 22.6667V9.33337C29.8332 7.12424 28.0423 5.33337 25.8332 5.33337H7.1665ZM6.93386 8.02027C7.0094 8.00697 7.08714 8.00004 7.1665 8.00004H25.8332C25.9125 8.00004 25.9903 8.00698 26.0658 8.02027L16.4999 14.3976L6.93386 8.02027ZM5.83317 10.4914V22.6667C5.83317 23.4031 6.43012 24 7.1665 24H25.8332C26.5695 24 27.1665 23.4031 27.1665 22.6667V10.4914L17.2395 17.1095C16.7916 17.408 16.2081 17.408 15.7603 17.1095L5.83317 10.4914Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.13d6b9c070a11165b3c97f06558b3e63.svg";
export { ForwardRef as ReactComponent };